import React from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../Services/AxiosAPICaller';
import { ILinkGroups } from '../../Interfaces/ILinkGroups';
import BackBtn from "../BackButton/BackButton";
import './LinkGroupDetail.css';

const BubbleDetail: React.FC = () => {
  const { Id } = useParams<{ Id: string }>();
  const [LinkGroups, setLinkGroup] = React.useState<ILinkGroups | null>(null);

  React.useEffect(() => {

    window.scrollTo(0, 0);

    axiosInstance.get< { data: { id: number, attributes: any }}>(`/groupe-de-liens/${Id}?populate[Image][fields][1]=url`)
      .then(response => {

        const item = response.data.data;

       // Create Bubble Object From API returned Datas
       const LinkGroups: ILinkGroups = {
        Id: item.id,
        Name:item.attributes.Nom,
        Description:item.attributes.Description ?? null,
        Image: item.attributes.Image?.data?.attributes?.url || '',
        Bubble: item.attributes.bulle ?? null,
        Links: item.attributes.liens_utiles ?? null
      };

      setLinkGroup(LinkGroups);
      })
      .catch(error => {
        console.error('Erreur lors de la récupération du groupe de contact:', error);
      });
  }, [Id]);

  if (!LinkGroups) return <p>Chargement des infos de groupes de Liens...</p>;

  return (
    <div className='TitleContainer'>
      {LinkGroups.Image && <img src={LinkGroups.Image} alt={LinkGroups.Name} style={{ width: '100%' }} />}
      <BackBtn></BackBtn>
      <h1 className='OpenedLinkGroupName'>{LinkGroups.Name}</h1>
      <p className='OpenedLinkGroupDesc'>{LinkGroups.Description}</p>
    </div>
  );
};

export default BubbleDetail;